import { Component, OnInit, Renderer2, AfterViewInit, HostListener } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { NgForm } from '@angular/forms';
import { AuthenticationResult } from '../models/authentication.model';
import { AuthenticationStatus } from '../enums/enums';
import { ServerResponse } from '../constants/server-response.model';

@Component({
  selector: 'app-auth-strict-id-choice',
  templateUrl: './auth-strict-id-choice.component.html',
  styleUrls: ['./auth-strict-id-choice.component.css']
})
export class AuthStrictIdChoiceComponent extends AuthBaseComponent implements OnInit, AfterViewInit {

  constructor(private renderer: Renderer2, protected modalService: ModalService, protected authService: AuthUserService) {
    super(modalService, authService);
  }

  public selectedTab = 0;

  private readonly minDate = new Date(1948, 4, 14)
  private readonly maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
  public isValidDate: boolean;
  public date = { day: '', month: '', year: '' };
  public cardNumberModal: string = '';
  public cvvModal: string = '';
  public isValidIssueDate: boolean;
  public issueDate = { day: '', month: '', year: '' };
  public data: any = {};
  private inputs: any = null;
  public serverError2 = null;

  @HostListener('input', ['$event']) onKeyDown(e: any) {
    let date = new Date(parseInt(this.issueDate.year), parseInt(this.issueDate.month) - 1, parseInt(this.issueDate.day));
    this.isValidIssueDate = date.getDate() == parseInt(this.issueDate.day) &&
      date.getMonth() + 1 == parseInt(this.issueDate.month) &&
      date.getFullYear() == parseInt(this.issueDate.year) &&
      date >= this.minDate && date < this.maxDate;
    if (this.selectedTab == 1 && e.srcElement.maxLength != null && e.srcElement.maxLength === e.srcElement.value.length) {
      e.preventDefault();
      let index = parseInt(e.srcElement.getAttribute('data-index'));
      if (this.inputs == null)
        this.inputs = this.inputsQuery.map(elm => elm.elementRef.nativeElement);

      if (index == this.inputs.length - 1) {
        document.querySelector('button').focus();
      }
      else {
        this.inputs[++index].focus();
      }
    }
  }

  elasticLogit() {
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2150' })
      .subscribe(res => console.log("sent elasticLog code:2150 - open window", res), error => console.log("sent elasticLog - open window error!", error));
  }
  ngOnInit() {
    this.elasticLogit();
    sessionStorage.setItem("currentWindow", "חלונית זיהוי מפוצלת");
    sessionStorage.setItem("elasticCode", "2948");
    this.data = this.modalService.data;
    this.isShowContactLink = this.shouldContactLink('authStrictChoice');
  }
  ngAfterViewInit() {
    const element = this.renderer.selectRootElement('#cardnumber');
    setTimeout(() => element.focus(), 0);
  }

  submitCreditCard(form: NgForm) {
    const element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element) {
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    
    if (form.valid && this.isValidDate) {
        this.pending = true;
        this.serverError = null;

        form.value.cardnumber.replace(' ', '');
        const card = {
          creditCardDetails: {
            CardNum: form.value.cardnumber.trim(),
            Month: form.value.month,
            Year: form.value.year,
            CVV: form.value.cvv
          }
        };
        //console.log("sent parametes", card);
        this.authUserService.sendAuthData("ValidateCreditCard", card)
          .subscribe((res: AuthenticationResult) => {
            if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidCreditCard") {
              this.elasticLogit();
              this.serverError = "פרטי האשראי שהוקלדו אינם תקינים או שאינו רשום על שמך. יש לבדוק ולנסות שוב."
            }
            else if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidCreditCardTech") {
              this.elasticLogit();
              this.serverError = "אירעה תקלה באימות פרטי כרטיס האשראי שלך. אנו מטפלים בתקלה. יש לנסות שוב במועד מאוחר יותר."
            }
            else {
              this.modalService.close(res.Details);
            }
          }, () => this.pending = false,
            () => this.pending = false
          )
      }
    this.buildFormAccessibility();
  }

  submitIssueDate(form: NgForm) {
    const element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element) {
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    
    if (form.valid && this.isValidIssueDate) {
        this.pending = true;
        this.serverError2 = null;
        //console.log("sent parametes", { ClientInsertedIdIssueDate: date });
        this.authUserService.sendAuthData("ValidateIdIssueDate", { year: parseInt(this.issueDate.year), month: parseInt(this.issueDate.month), day: parseInt(this.issueDate.day) })
          .subscribe((res: AuthenticationResult) => {
            if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidIssueDate") {
              this.elasticLogit();
              this.serverError2 = "תאריך הנפקת תעודת הזהות אינו מתאים. אנא נסו שוב.";
            }
            else {
              this.modalService.close(res.Details);
            }
          }, () => this.pending = false,
            () => this.pending = false
          )
      }
    this.buildFormAccessibility();
  }

  validateDate() {
    this.isValidDate = new Date().getMonth() + 1 <= parseInt(this.date.month) &&
      new Date().getFullYear() == parseInt(`20${this.date.year}`) || new Date().getFullYear() < parseInt(`20${this.date.year}`)
  }
  // validateIssueDate() {
  //   let date = new Date(parseInt(this.issueDate.year), parseInt(this.issueDate.month) - 1, parseInt(this.issueDate.day));
  //   this.isValidDate = date.getDate() == parseInt(this.date.day) &&
  //     date.getMonth() + 1 == parseInt(this.date.month) &&
  //     date.getFullYear() == parseInt(this.date.year) &&
  //     date >= this.minDate && date < this.maxDate;
  //   //console.log(this.isValidDate);
  // }

  selectTab(index) {
    this.selectedTab = index;
    this.inputs = null;

    return false;
  }
}
